module.exports = __webpack_public_path__ + "img/Stemness-OSCC_GSE208253.02f27e91.png";